/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { addLatestQuestion, fetchChats, fetchLastChat, selectChats } from '../../redux/askCreatorSlice'
import { useState } from 'react'
import { selectCurrentCourseId } from '../../redux/courseListSlice'
import { Mixpanel } from '../../config/Mixpanel'
import constants from '../../utilities/constants'
import useWindowSize from '../../hooks/useWindowSize'

const predefinedQuestionList = [
    "Give me a few examples to understand this better.",
    "Simplify the video as if explaining to a 10 year old.",
    "Give a few top tips & tricks to implement this in my work."
]


const ChatSection = ({ video_id, module_slug, lesson_id }) => {

    const [ userQuery, setUserQuery ] = useState("")
    const dispatch = useDispatch()
    const courseId = useSelector(selectCurrentCourseId)
    const { chat_history, error, loadingMessage } = useSelector(selectChats)
    const scrollRef = useRef(null)
    const { width } = useWindowSize()
       
    useEffect(() => {
        if (module_slug && lesson_id !== null && lesson_id !== undefined){
            dispatch(fetchChats({ course_id: courseId, module_slug, lesson_id }))
        }
    }, [courseId, module_slug, lesson_id])

    const handleClick = (item) => {
        Mixpanel.track(constants.Mixpanel.LESSON_PAGE_PRE_DEFINED_DOUBT_WAS_CLICKED)
        const fetchData = async () => {
            try {
                await dispatch(addLatestQuestion({role:"user", content: item}))
                await dispatch(fetchLastChat({ course_id: courseId, module_slug, video_id, lesson_id, query: item })).unwrap()
            }catch (err) {
                console.log(err.message);
            }
        }
        fetchData()
    }

    useEffect(() => {
        const parentElement = scrollRef?.current;
        const lastChild = parentElement?.lastChild;

        if (lastChild && width >= 1024) {
            lastChild.scrollIntoView({ behavior: 'smooth' });
        }
    }, [scrollRef, chat_history?.length])

    const handleUserDoubt = (e) => {
        e.preventDefault()
        Mixpanel.track(constants.Mixpanel.LESSON_PAGE_DOUBT_WAS_ASKED)
        dispatch(addLatestQuestion({role:"user", content: userQuery}))
        dispatch(fetchLastChat({ course_id: courseId, module_slug, video_id, lesson_id, query: userQuery }))
        setUserQuery("")
    }
    
     
    return (
        <div className='reactour-chatsection rounded-xl border border-white/10 bg-gradient-to-br from-[#17395A] to-[#102D47] p-3 lg:p-6'>
            {
                chat_history?.length <= 0 ? predefinedQuestionList?.map((item, index) => (
                    <p key={index} className='mb-2 cursor-pointer rounded-xl border border-[#456B8D] px-1 py-2 text-center text-sm text-[#8CC6FF]' onClick={() => handleClick(item)}>
                        {item}
                    </p>
            )) : 
                <div ref={scrollRef} className='flex flex-col justify-start h-[400px] lg:h-[228px] overflow-y-scroll takeaway'>
                    {chat_history?.map((item, index)=> (
                        <div key={index} className={`mt-3 max-w-[80%] p-2 text-sm leading-[17px] ${item?.role === 'user' ? 'mr-2 self-end rounded-xl border-2 border-[#456B8D]' : item?.role === 'system' && item?.content?.includes("https://personlaize-data-bucket.s3.amazonaws.com") ? "" : 'self-start rounded-xl bg-[#244968]'}`}>
                            {item?.content?.split('\n')?.map((point, pointIndex) => (
                                <p key={pointIndex} className={`${item?.role === 'system' ? 'mb-2' : ''}`}>{point}</p>
                            ))}
                        </div> 
                    ))}
                    {loadingMessage ? <p>Loading...</p> : null}
                    {error ? <p>Something went wrong try again later</p> : null}
                </div>
            }
            {predefinedQuestionList.length !== 0 && chat_history?.length <= 0 ? <p className='text-center my-4'>or</p> : null}
            <form onSubmit={handleUserDoubt}>
                <div className='relative mt-3'>
                    <input 
                        type="text"
                        placeholder='Ask your question'
                        disabled={loadingMessage}
                        value={userQuery}
                        onChange={(e) => setUserQuery(e.target.value)}
                        className='w-full rounded-xl py-2.5 bg-[#17395A] placeholder:text-white/50 placeholder:text-sm outline-none border-none answer_text pr-14'
                    />
                    <button type='submit' disabled={!userQuery || loadingMessage} className='absolute right-3 top-1/2 -translate-y-1/2 transform bg-[#17395A] text-sm text-[#8CC6FF] disabled:opacity-50'>Send</button>
                </div>
            </form>
        </div>
    )
}

export default ChatSection
